﻿
angular.module('fliptoWeb')
    .directive('ftHoverPanels', [function () {
        return {
            restrict: 'EA',
            scope: {
                hoverClass: '@?',
                keepLastOpen: '=?'
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: function HoverPanelsComponent() {
                this.panels = [];

                this.addPanel = function (panel) {
                    this.panels.push(panel);
                    if (angular.isDefined(panel.attrs.active)) {
                        this.setActivePanel(panel);
                    }
                };

                this.setActivePanel = function (newActivePanel) {
                    this.panels.forEach(panel => { panel.active = false; });
                    newActivePanel.active = true;
                };

                this.removeActivePanel = function (panel) {
                    panel.active = false;
                };
            }
        };
    }])
    .directive('ftHoverPanel', [function () {
        return {
            restrict: 'EA',
            require: '^ftHoverPanels',
            link: function (scope, elem, attrs, hoverPanelsCtrl) {

                let panel = {
                    elem: elem,
                    attrs: attrs,
                    active: false
                };

                scope.$watch(() => panel.active, function (isActive) {
                    toggleHoverClass(isActive);
                }, true);
                hoverPanelsCtrl.addPanel(panel);

                elem.on('mouseenter', setActivePanel);
                if (!hoverPanelsCtrl.keepLastOpen) {
                    elem.on('mouseleave', removeActivePanel);
                }

                scope.$on("$destroy", () => {
                    elem.off("mouseenter", setActivePanel);
                    if (!hoverPanelsCtrl.keepLastOpen) {
                        elem.off("mouseleave", removeActivePanel);
                    }
                });

                function setActivePanel() {
                    scope.$apply(function () {
                        hoverPanelsCtrl.setActivePanel(panel);
                    });
                }

                function removeActivePanel() {
                    scope.$apply(function () {
                        hoverPanelsCtrl.removeActivePanel(panel);
                    });
                }

                function toggleHoverClass(isOn) {
                    if (isOn) {
                        elem.addClass(hoverPanelsCtrl.hoverClass);
                    } else {
                        elem.removeClass(hoverPanelsCtrl.hoverClass);
                    }
                }
            }
        };
    }]);